/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {
    RouterModule,
    Routes
} from '@angular/router';
import {RoutingMenuItemModel} from '../shared/utils/routing-menu-item.model';
import {PermissionsGuard} from '../permissions.guard';
import {UnsavedChangesGuard} from '../shared/guards/unsaved-work/unsaved-changes.guard';
import {PartNumberChangesCreateNewComponent} from './part-number-changes-create-new/part-number-changes-create-new.component';
import {Permission} from '../shared/utils/permission.enum';
import {PartNumberChangesMainPageComponent} from './part-number-changes-main-page/part-number-changes-main-page.component';

export const routes: Routes = [
    {
        path: 'pnc',
        canActivate: [PermissionsGuard],
        canActivateChild: [PermissionsGuard],
        data: {
            hasSideBarMenu: true,
            breadcrumb: 'PNC',
            permissions: [
                Permission.PARTNER_PNC_VIEW,
                Permission.PLANNER_PNC_VIEW,
                Permission.PRICE_PLANNER_PNC_VIEW,
                Permission.TECHNICIAN_PNC_VIEW,
                Permission.ADMIN_PNC_VIEW,
                Permission.EE_SPECIALIST_PNC_VIEW
            ],
            menuItem: {
                label: 'PNC',
                icon: 'iwp-icon-gen_exchange',
                index: 3
            } as RoutingMenuItemModel
        },
        children: [
            {
                path: '',
                component: PartNumberChangesMainPageComponent,
                data: {
                    hasSideBarMenu: true,
                    hasStickyHeader: true,
                    permissions: [
                        Permission.PARTNER_PNC_VIEW,
                        Permission.PLANNER_PNC_VIEW,
                        Permission.PRICE_PLANNER_PNC_VIEW,
                        Permission.TECHNICIAN_PNC_VIEW,
                        Permission.ADMIN_PNC_VIEW,
                        Permission.EE_SPECIALIST_PNC_VIEW
                    ],
                    menuItem: {
                        label: 'View list'
                    } as RoutingMenuItemModel
                }
            },
            {
                path: 'new',
                component: PartNumberChangesCreateNewComponent,
                canDeactivate: [UnsavedChangesGuard],
                data: {
                    hasSideBarMenu: true,
                    breadcrumb: 'CREATE NEW PNC',
                    permissions: [Permission.PARTNER_PNC_CREATE, Permission.PLANNER_PNC_CREATE],
                    menuItem: {
                        label: 'New',
                        index: 1
                    } as RoutingMenuItemModel
                }
            }
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PartNumberChangesRoutingModule {
}
